import '../css/index.less';
import './components/wxshare';
import simulator from './components/simulator';

require('../images/prize/10.png');

const _index = {
  options: {},
  Init: function() {
    this.Events();
    $('#scene') && $('#scene').parallax({});
  },
  Events: function() {
    this.loginIn(); //登录
    this.OpenBox(); //开箱
    this.OpenBoxRecord(); //开箱记录
    this.WriteInfo(); //填写账号信息
    this.Close(); //关闭弹窗
    this.JDetermine();
  },
  loginIn() {
    const that = this;
    let j_login = $('.j-showdialog');
    j_login.click(() => {
      $("#j_modal_login .code").html(
        `<iframe marginwidth="0" frameborder="no" scrolling="no" id="iframe_login" width="282" height="408" src="${code_url}"></iframe>`
      );
      that.modalOpen($('#j_modal_login'));
    });

    //登录后提示没有绑定CSGO账号的用户
    let J_bind_csgo = $('#J_bind_csgo');
    if(J_bind_csgo.hasClass('open-bind-csgo')){
      that.modalOpen(J_bind_csgo);
    }
  },
  OpenBox: function() {
    const that = this;

    let J_openBox = $('#J_openBox');
    let J_open_btn = $('.footer-right a');
    let J_open_key = $('#j_open_key a');

    if (key_num <= 0) {
      J_open_btn.addClass('disabled').attr('id', '');
    }
    // 开箱
    J_openBox.click(() => {
      if (is_login) {
        if (key_num <= 0) return false;
        $.ajax({
          url: '/csgolottery201910',
          method: 'POST',
          data: {
            task: 'getPrize'
          },
          dataType: 'json',
          success: function(res) {
            var data = res;
            if (data.status === 'success') {
              var _index = $(
                '#list li[data-id="' + data.info.id + '"]'
              ).index();
              key_num > 0 ? $('#key_num').text(--key_num) : '';
              that.chooClose($('.chooses'));
              J_openBox.html('再开一次');
              simulator.Start(_index, function() {
                that.chooClose($('.open-ani'));
                that.updateResults(data.info, false);
                that.chooOpen($('.open-results'));
                $('#list .hove').removeClass('hove');
                if (data.need_contact_info === 'y') {
                  that.modalOpen($('#J_user-info'));
                  $(".address-box").html("")
                    .html(`<p class="p-txt">抽中的虚拟道具如钥匙、皮肤将会直接发到游戏库存中。抽中实物奖励需点击填写收货信息，活动结束后统一配送。</p>
                              <a class="login-btn" href="javascript:void(0);" id="J_write">请填写详细账号信息</a>`);
                } else if (key_num <= 0) {
                  J_open_btn.addClass('disabled').attr('id', '').html('开箱');
                }
              });
              that.chooOpen($('.open-ani'));
              if (key_num <= 0) {
                J_open_btn.addClass('disabled').attr('id', '');
              }
              if (data.need_contact_info === 'y') {
                $("#share_items").html(`
                  <i></i>
                  <a href="javascript:wmShare.baiduT(wmShare.url)" title="分享到百度贴吧" class="tieba share_line_baiduT"></a>
                  <a href="javascript:wmShare.weixin(wmShare.url)" title="分享到微信" class="weixin share_line_weixin"></a>
                  <a href="javascript:wmShare.sinaT(wmShare.url, '#2019完美盛典CSGO福利活动#参与完美盛典投票，鸡神给我发福利！我抽到了 ${data.info.name} 运气不错！活动还精美外设、隐秘级皮肤等大奖，点击参与【活动页地址】', '${data.info.img}')" title="分享到新浪微博" class="weibo share_line_sinaT"></a>
                `);
              } else {
                if (data.info.name == "谢谢参与") {
                  $("#share_items").html(`
                    <i></i>
                    <a href="javascript:wmShare.baiduT(wmShare.url)" title="分享到百度贴吧" class="tieba share_line_baiduT"></a>
                    <a href="javascript:wmShare.weixin(wmShare.url)" title="分享到微信" class="weixin share_line_weixin"></a>
                    <a href="javascript:wmShare.sinaT(wmShare.url, '#2019完美盛典CSGO福利活动#参与2019完美盛典CSGO福利活动，投票即可赢取限量电竞外设', '${data.info.img}')" title="分享到新浪微博" class="weibo share_line_sinaT"></a>
                  `);
                }else{
                  $("#share_items").html(`
                    <i></i>
                    <a href="javascript:wmShare.baiduT(wmShare.url)" title="分享到百度贴吧" class="tieba share_line_baiduT"></a>
                    <a href="javascript:wmShare.weixin(wmShare.url)" title="分享到微信" class="weixin share_line_weixin"></a>
                    <a href="javascript:wmShare.sinaT(wmShare.url, '#2019完美盛典CSGO福利活动#参与完美盛典投票，鸡神给我发福利！我抽到了 ${data.info.name} ，运气不错！活动还精美外设、隐秘级皮肤等大奖，点击参与【活动页地址】', '${data.info.img}')" title="分享到新浪微博" class="weibo share_line_sinaT"></a>
                `);
                }
              }
            } else {
              that.msg(data.msg);
              J_open_btn.addClass('disabled').attr('id', '');
            }
          },
          error: function(err) {
            console.log(err);
          }
        });
      } else {
        $('.btn_log_in').trigger('click');
      }
    });
    //选择额外奖品
    J_open_key.click(e => {
      let me = $(e.target);
      if (me.data('type') === 0) {
        that.modalClose();
        $.ajax({
          url: '/csgolottery201910',
          method: 'POST',
          data: {
            task: 'setPrizeType',
            type: 'fix'
          },
          dataType: 'json',
          success: function(res) {
            if (res.status === 'success') {
              setTimeout(() => {
                $('.lottery-caps')
                  .html(`<p>恭喜您获得 <span>${res.info.name}</span> 一枚</p>
                            <p>奖励将在抽奖结束后15天内发送到您的库存</p>
                            <div class="caps-img">
                                <img src="${res.info.img}" alt="">
                            </div>`);
                that.modalOpen($('#J_lottery_caps'));
              }, 600);
            }
          },
          error: function(err) {
            console.log(err);
          }
        });
      } else if (me.data('type') === 1) {
        that.modalClose();
        $.ajax({
          url: '/csgolottery201910',
          method: 'POST',
          data: {
            task: 'setPrizeType',
            type: 'rand'
          },
          dataType: 'json',
          success: function(res) {
            if (res.status === 'success') {
              window.location.reload();
            }
          },
          error: function(err) {
            console.log(err);
          }
        });
      }
    });
    //忘记完美通行证
    $('#j_btn_steam').click(() => {
      that.modalOpen($('#J_user-steam'));
    });
    $('#user-steam-items').mCustomScrollbar({
      axis: 'y',
      theme: 'light-3',
      autoExpandScrollbar: true,
      advanced: { autoExpandHorizontalScroll: true }
    });

    //关闭刷新
    $('#close_reload').click(() => {
      window.location.reload();
    });
  },
  OpenBoxRecord: function() {
    let items = $('.res-items li');
    if (items.length > 13) $('#j_res-items').scroll();
  },
  updateResults: function(info, bool) {
    var data = info;
    var J_open_results = $('.results-box');
    var bool = bool || false;
    if (bool) {
      $('#res-items').append(`
          <li>
              <p>恭喜玩家 <span title="${data.steam_nickname}">${data.steam_nickname}</span> 在抽奖中获得</p>
              <p>${data.name}</p>
          </li>
      `);
      } else {
        J_open_results.html('').html(`
            <div class="results-header">
                <span class="colors color${data.show_color}"></span>
                <h2>${data.name}</h2>
                <p>${data.result_txt}</p>

            </div>
            <div class="results-body">
                <img src="${data.img}" alt="">
            </div>
            <p class="desc_txt">${data.desc_txt}</p>
            `);
        }
      },
  WriteInfo: function() {
    const that = this;
    var $form = $('#form');

    $(document).on('click', '#J_write', () => {
      that.modalOpen($('#J_user-info'));
    });

    $form.find('#J_submit').click(() => {
      that.VerifyFormat();

      //手机号验证
      var _user_phone = $form.find('[name="phone"]');
      if (!that.isPhone(_user_phone.val()) && !_user_phone.hasClass('error')) {
        _user_phone.addClass('error');
      }
      $form.find('[name="phone"]').on('blur', function() {
        if (!that.isPhone(this.value) && !$(this).hasClass('error')) {
          $(this).addClass('error');
        }
      });

      if ($form.find('.error').length === 0) {
        that.options.task = 'saveContactInfo';
        $.ajax({
          url: '/csgolottery201910',
          data: that.options,
          dataType: 'json',
          success: function(data) {
            var data = data;
            that.modalClose();
            setTimeout(function() {
              that.msg(data.msg);
            }, 500);
          },
          error: function(error) {
            console.log(error);
          }
        });
      }
    });
  },
  Close: function() {
    const that = this;

    $('.close').click(() => {
      that.modalClose();
    });

    // 关闭奖品展示
    $('.res-close').click(() => {
      that.chooOpen($('.chooses'));
      that.chooClose($('.open-results'));
    });
  },
  JDetermine: function() {
    var that = this;

    $('#J_determine').click(function() {
      that.modalClose();
    });
  },
  modalOpen: function(modal_target) {
    let _right = this.getScrollWidth();
    $('body')
      .addClass('modal-open')
      .css('padding-right', _right);

    this.addModal(false);
    $(modal_target).css('display', 'block');
    $(modal_target).css('display');
    $(modal_target)
      .css({
        paddingRight: '17px'
      })
      .addClass('in');
  },
  chooOpen: function(modal_target) {
    $(modal_target).css('display', 'block');
    $(modal_target).css('display');
    $(modal_target).addClass('in');
  },
  modalClose: function() {
    $('.modal').removeClass('in');
    $('.modal-backdrop').removeClass('in');
    setTimeout(() => {
      $('.modal').attr('style', '');
      $('.modal-backdrop').remove();
      $('body')
        .removeClass('modal-open')
        .attr('style', '');
    }, 100);
  },
  chooClose: function(target) {
    target.removeClass('in');
    setTimeout(() => {
      target.attr('style', '');
    }, 100);
  },
  addModal: function() {
    $('body').append('<div class="modal-backdrop fade in"></div>');
  },
  getScrollWidth: function() {
    return window.innerWidth - document.body.clientWidth;
  },
  VerifyFormat: function() {
    var $from = $('#form');
    var $required = $from.find('[required]');
    var that = this;

    //智能清除提示
    $required.on('input propertychange', function() {
      $(this)
        .removeClass('error')
        .next('.v-message')
        .remove();
    });

    //判断是否为空
    $required.each(function() {
      if (that.isEmpty(this.value) && !$(this).hasClass('error')) {
        $(this).addClass('error');
      }
      that.options[$(this).attr('name')] = this.value;
    });
  },
  msg: function(txt) {
    var that = this;
    that.modalOpen($('#J_message'));
    $('.maggess')
      .html(' ')
      .html(txt);
  },
  isEmpty: function(str) {
    return '' == str.replace(/^\s+|\s+$/, '');
  },
  isPhone(str) {
    return /^1\d{10}$/.test(str);
  }
};

$(function(){
    _index.Init();
});
